import classes from "./LiveButton.module.scss";
import live1 from "components/icons/live-1.webp";
import live2 from "components/icons/live-2.webp";
import live3 from "components/icons/live-3.webp";
import { links } from "./config/liveButton";
import { useDeviceType } from "hooks";
import { deviceTypeEnum } from "hooks/useDeviceType";
import { useCallback, memo } from "react";

const liveImages = [live1, live2, live3];

const LiveButton = memo(() => {
  const isDesktop = useDeviceType() === deviceTypeEnum.DESKTOP;

  const handleClick = useCallback(() => {
    window.location.href = isDesktop ? links.desktop : links.mobile;
  }, [isDesktop]);

  const liveImage = liveImages[Math.floor(Math.random() * liveImages.length)];

  return (
    <div className={classes.advertLiveButton} onClick={handleClick}>
      <div className={classes.flash}></div>
      <div className={classes.imageWrapper}>
        <img className={classes.image} src={liveImage} width={26} height={26} alt="" />
      </div>
      <div className={classes.textWrapper}>
        <span className={classes.text}>LIVE</span>
      </div>
    </div>
  );
});

export default LiveButton;
